<template>
  <div class="login-container">
    <!-- 背景图片 -->
    <div class="background-image">
      <div class="anime-background"></div>
    </div>
    
    <!-- 登录表单 -->
    <el-card class="login-form" shadow="always">
      <div class="form-header">
        <h1 class="main-title">万维智慧云文档</h1>
        <p class="subtitle">文档管理系统</p>
      </div>
      
      <el-form 
        ref="loginForm" 
        :model="loginForm" 
        :rules="rules" 
        @submit.native.prevent="handleLogin"
        class="form-content"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            type="text"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            size="large"
            clearable
          />
        </el-form-item>
        
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="large"
            show-password
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button
            type="primary"
            size="large"
            :loading="loading"
            @click="handleLogin"
            class="login-btn"
          >
            {{ loading ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
      
      <div class="form-footer">
        <!-- <div class="footer-left">
          <el-link type="primary" :underline="false">注册</el-link>
          <span class="separator">|</span>
          <el-link type="primary" :underline="false">忘记密码</el-link>
        </div>
        <div class="footer-right">
          <el-dropdown @command="handleLanguageChange">
            <span class="language-selector">
              <i class="el-icon-global"></i>
              简体中文
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh-CN">简体中文</el-dropdown-item>
              <el-dropdown-item command="en-US">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div> -->
      </div>
    </el-card>
  </div>
</template>

<script>
import { AUTH_PATHS } from '@/api/paths'
import { tokenUtils, userUtils } from '@/utils/auth'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loading: false,
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
  },
  methods: {
    async handleLogin() {
      // 表单验证
      try {
        await this.$refs.loginForm.validate()
      } catch (error) {
        return
      }
      
      this.loading = true
      try {
        // 调用登录接口
        const response = await this.$post(AUTH_PATHS.LOGIN, {
          username: this.loginForm.username,
          password: this.loginForm.password
        })
        
        // 检查响应格式
        if (response.data && response.data.code === 200) {
          // 保存token和用户信息到本地存储
          const userData = response.data.data
          if (userData && userData.token) {
            tokenUtils.setToken(userData.token)
            userUtils.setUserInfo(userData.user || {})
          }
          
          this.$message.success(response.data.msg || '登录成功')
          
          // 登录成功按角色加载对应路由表并跳转
          const redirect = this.$route.query.redirect
          if (redirect && redirect !== '/login') {
            window.location.href = redirect
          } else {
            const userRole = userData.user?.role
            if (userRole === 'admin') {
              window.location.href = '/admin/users'
            } else {
              window.location.href = '/'
            }
          }
        } else {
          this.$message.error(response.data?.msg || '登录失败')
        }
        
      } catch (error) {
        console.error('登录失败:', error)
        this.$message.error(error.response?.data?.msg || '登录失败，请检查用户名和密码')
      } finally {
        this.loading = false
      }
    },
    
    handleLanguageChange(command) {
      this.$message.info(`切换到${command === 'zh-CN' ? '简体中文' : 'English'}`)
    }
  }
}
</script>

<style scoped>
.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.anime-background {
  width: 100%;
  height: 100%;
  /* 背景图片 - 请将图片命名为 login-bg.jpg 并放到 src/assets/ 目录 */
  background-image: url('../assets/login-bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

/* 添加半透明遮罩层，让登录表单更清晰可见 */
.anime-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: rgba(0, 0, 0, 0.2); */
  /* 如果不需要遮罩层，可以将上面的 background 改为 transparent */
}

.login-form {
  position: relative;
  z-index: 2;
  width: 400px;
  max-width: 90vw;
}

.login-form >>> .el-card__body {
  padding: 40px 35px;
}

.form-header {
  text-align: center;
  margin-bottom: 30px;
}

.main-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 0 0 8px 0;
  font-family: 'Microsoft YaHei', sans-serif;
}

.subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
  font-family: 'Microsoft YaHei', sans-serif;
}

.form-content {
  margin-bottom: 25px;
}

.input-group {
  margin-bottom: 20px;
}

.form-input {
  width: 100%;
  height: 45px;
  padding: 0 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  background: #fff;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #20b2aa;
  box-shadow: 0 0 0 2px rgba(32, 178, 170, 0.1);
}

.form-input::placeholder {
  color: #999;
}

.login-btn {
  width: 100%;
  height: 45px;
  font-size: 16px;
  font-weight: 500;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.footer-left {
  display: flex;
  align-items: center;
}

.footer-link {
  color: #666;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #20b2aa;
}

.separator {
  margin: 0 8px;
  color: #ddd;
}

.footer-right {
  display: flex;
  align-items: center;
}

.language-selector {
  color: #666;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .login-form {
    width: 90%;
    max-width: 400px;
  }
  
  .login-form >>> .el-card__body {
    padding: 30px 25px;
  }
  
  .main-title {
    font-size: 24px;
  }
  
  .subtitle {
    font-size: 13px;
  }
  
  .form-footer {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .login-form {
    width: 95%;
    padding: 25px 20px;
  }
  
  .login-form >>> .el-card__body {
    padding: 25px 20px;
  }
  
  .main-title {
    font-size: 20px;
  }
  
  .subtitle {
    font-size: 12px;
  }
  
  .form-content {
    margin-bottom: 20px;
  }
  
  .login-btn {
    height: 42px;
    font-size: 15px;
  }
}
</style>
